import { alpha } from "@mui/material/styles";
import { ORDER_RANKING, STATUS_LATE_RELEVANT } from "../../types/order";

export const getOrderIndexBadgeColor = (order, ordersToDispatch, theme) => {
  const isInDispatchQueue = ordersToDispatch.includes(order.order_id);
  const orderIndexBadgeColor = isInDispatchQueue ? "#FFEB3B" : null;

  if (orderIndexBadgeColor) {
    return orderIndexBadgeColor;
  }

  const statusColorMap = {
    2: "#FF6B35",
    7: "#2196F3",
  };

  const statusColor = statusColorMap[order.status_number];
  const fallbackColor = theme.palette.primary.main;

  return statusColor || fallbackColor;
};

export const getOrderBackgroundColor = (order, theme) => {
  const { is_customer_on_blacklist, status_number, lateStatus, isAlmostLate } =
    order;

  if (is_customer_on_blacklist) {
    return alpha(theme.palette.error.main, 0.08);
  }

  if (status_number === 0) {
    return null;
  }

  const isStatusRelevantForLate = STATUS_LATE_RELEVANT.includes(status_number);

  if (lateStatus && isStatusRelevantForLate) {
    return alpha(theme.palette.error.main, 0.1);
  }

  if (isAlmostLate && isStatusRelevantForLate) {
    return alpha(theme.palette.warning.main, 0.1);
  }

  return null;
};

export const getOrderBorderColor = (isBlacklisted, theme) => {
  const blacklistColor = alpha(theme.palette.error.main, 0.4);
  const defaultColor = alpha(theme.palette.grey[300], 0.7);

  return isBlacklisted ? blacklistColor : defaultColor;
};

export const getTotalChipStyling = (rankingByTotal, theme) => {
  const specialStyling = {
    variant: "filled",
    sx: {
      bgcolor: "#FFD700",
      color: "#8B4513",
      fontWeight: 700,
      "& .MuiChip-icon": {
        color: "#DAA520",
      },
    },
  };

  const lowStyling = {
    variant: "outlined",
    sx: {
      borderColor: alpha("#E53E3E", 0.5),
      color: "#E53E3E",
      "& .MuiChip-icon": {
        color: "#E53E3E",
      },
    },
  };

  const regularStyling = {
    variant: "standard",
    sx: {
      bgcolor: alpha(theme.palette.grey[500], 0.1),
      color: theme.palette.text.secondary,
      "& .MuiChip-icon": {
        color: theme.palette.success.main,
      },
    },
  };

  if (rankingByTotal === ORDER_RANKING.SPECIAL) {
    return specialStyling;
  }

  if (rankingByTotal === ORDER_RANKING.LOW) {
    return lowStyling;
  }

  return regularStyling;
};

export const getTimeChipStyling = (order, theme) => {
  const { lateStatus, isAlmostLate, status_number } = order;
  const isStatusRelevant = STATUS_LATE_RELEVANT.includes(status_number);

  if (lateStatus && isStatusRelevant) {
    return {
      bgcolor: alpha(theme.palette.error.main, 0.2),
      color: theme.palette.error.main,
      fontWeight: 700,
      iconColor: theme.palette.error.main,
    };
  }

  if (isAlmostLate && isStatusRelevant) {
    return {
      bgcolor: alpha(theme.palette.warning.main, 0.2),
      color: theme.palette.warning.main,
      fontWeight: 700,
      iconColor: theme.palette.warning.main,
    };
  }

  return {
    bgcolor: alpha(theme.palette.grey[500], 0.1),
    color: theme.palette.text.secondary,
    fontWeight: 400,
    iconColor: theme.palette.text.secondary,
  };
};
